

import TiwiMixin from '../mixins/TiwiMixin'
import VueWriter from "vue-writer";


export default {
  mixins: [ TiwiMixin ],
  components: {VueWriter},
  props: {
    storyEditorUrl: {
      required: true,
      type: String,
    },
    avatarUrl: {
      required: true,
      type: String,
    },
    sentences: {
      required: false,
      type: Array,
      default: ['Cosa ti ha portato a insegnare?']
    },
    
    
  },
  methods: {
    gotoEditor: function(){
      window.location.href = this.storyEditorUrl
    }
  }

}
